/**
 * Зеркалирование в metrika /collect/ — не вызывает SDK, только пишет metric_call.
 * Вызывать после (или рядом с) существующими yaCounter / ga / _tmr / rrApi.
 */

const YANDEX_COUNTER_ID = 46243086;

export function logYandexReachGoalConsole(goal) {
    if (typeof console === 'undefined' || typeof console.log !== 'function') {
        return;
    }

    console.log('collectYandexReachGoal', goal);
}

function wrapYmReachGoalLog(fn) {
    if (typeof fn !== 'function' || fn.__yandexReachGoalLogWrapped) {
        return fn;
    }

    function wrappedYm(...args) {
        if (args[0] === YANDEX_COUNTER_ID && args[1] === 'reachGoal' && args[2] != null && args[2] !== '') {
            logYandexReachGoalConsole(String(args[2]));
        }

        return fn.apply(this, args);
    }

    wrappedYm.__yandexReachGoalLogWrapped = true;

    return wrappedYm;
}

/**
 * Лог reachGoal из inline ym(...) в шаблонах (до/после загрузки tag.js).
 */
export function installYandexReachGoalConsoleLog() {
    if (typeof window === 'undefined' || window.__yandexReachGoalConsoleLogInstalled) {
        return;
    }

    window.__yandexReachGoalConsoleLogInstalled = true;

    let ymValue = typeof window.ym === 'function' ? wrapYmReachGoalLog(window.ym) : undefined;

    try {
        Object.defineProperty(window, 'ym', {
            configurable: true,
            enumerable: true,
            get() {
                return ymValue;
            },
            set(fn) {
                ymValue = wrapYmReachGoalLog(fn);
            },
        });
    } catch (e) {
        if (typeof window.ym === 'function') {
            window.ym = wrapYmReachGoalLog(window.ym);
        }
    }
}

export function collectMetric(collector, event) {
    const {data, context, ...rest} = event;

    collector.track({
        status: 'called',
        data: data ?? {},
        context: context ?? {},
        ...rest,
    });
}

export function collectYandexReachGoal(collector, goal, options = {}) {
    logYandexReachGoalConsole(goal);

    collectMetric(collector, {
        provider: 'yandex',
        action: 'reachGoal',
        data: {goal, ...(options.data || {})},
        context: options.context,
        pageUrl: options.pageUrl,
        orderId: options.orderId,
    });
}

export function collectGoogleEvent(collector, eventCategory, eventAction, options = {}) {
    collectMetric(collector, {
        provider: 'google',
        action: 'event',
        data: {
            event: options.event || eventAction,
            eventCategory,
            eventAction,
            ...(options.eventLabel != null ? {eventLabel: options.eventLabel} : {}),
            ...(options.eventValue != null ? {eventValue: options.eventValue} : {}),
            ...(options.page ? {page: options.page} : {}),
        },
        context: options.context,
        orderId: options.orderId,
    });
}

export function collectMailruReachGoal(collector, goal, options = {}) {
    collectMetric(collector, {
        provider: 'mailru',
        action: 'reachGoal',
        data: {
            goal,
            id: options.id ?? 3512243,
            ...(options.data || {}),
        },
        context: options.context,
        orderId: options.orderId,
    });
}

export function collectYandexPurchase(collector, orderId, products, options = {}) {
    collectMetric(collector, {
        provider: 'yandex',
        action: 'purchase',
        data: {
            id: orderId,
            products,
            ...(options.data || {}),
        },
        orderId,
    });
}

export function collectRetail(collector, action, options = {}) {
    collectMetric(collector, {
        provider: 'retail',
        action,
        data: options.data || {},
        context: {rrApiOnReady: true, ...(options.context || {})},
        orderId: options.orderId,
    });
}

